import {EventBus} from '@/app-core/lib/events/eventBus'

const IS_DEV = import.meta.env.MODE === 'development'

export default {
  Emit: (Event, Payload) => {

    IS_DEV && console.info('%c%s%c%s', 'color: MediumPurple', 'DataEventService.', 'color: DodgerBlue', 'Emit:', Payload || '')
    EventBus.$emit(Event, Payload)
  },

  On: (Event, Callback) => {

    IS_DEV && console.info('%c%s%c%s', 'color: MediumPurple', 'DataEventService.', 'color: SpringGreen', 'On:', Callback?.name || '')
    EventBus.$on(Event, Callback)
  },

  Off: (Event, Callback) => {

    IS_DEV && console.info('%c%s%c%s', 'color: MediumPurple', 'DataEventService.', 'color: OrangeRed', 'Off:', Callback?.name || '')
    EventBus.$off(Event, Callback)
  }
}
